/**
 * AML的状态
 */
export enum CRAStatus {
  /**
   * 审核中
   */
  CRA_UNDER_REVIEW = "CRA_UNDER_REVIEW",
  /**
   * 合规审核通过
   */
  CRA_APPROVED = "CRA_APPROVED",
  /**
   * 合规审核拒绝
   */
  CRA_REJECTED = "CRA_REJECTED",
}

/**
 * null
 */
export enum Creator {
  /**
   * 用户
   */
  USER = "USER",
  /**
   * 管理员
   */
  ADMIN = "ADMIN",
}

/**
 * IRA状态
 */
export enum IRAStatus {
  /**
   * 未通过
   */
  IRA_FAILED = "IRA_FAILED",
  /**
   * 通过
   */
  IRA_PASSED = "IRA_PASSED",
  /**
   * 待提交
   */
  IRA_TO_BE_SUBMIT = "IRA_TO_BE_SUBMIT",
  /**
   * 已过期
   */
  IRA_EXPIRED = "IRA_EXPIRED",
}

/**
 * IRA风险等级
 */
export enum IRARiskLevel {
  /**
   * 低风险
   */
  IRA_RISK_LEVEL_LOW = "IRA_RISK_LEVEL_LOW",
  /**
   * 中低风险
   */
  IRA_RISK_LEVEL_LOW_MEDIUM = "IRA_RISK_LEVEL_LOW_MEDIUM",
  /**
   * 中风险
   */
  IRA_RISK_LEVEL_MEDIUM = "IRA_RISK_LEVEL_MEDIUM",
  /**
   * 中高风险
   */
  IRA_RISK_LEVEL_MEDIUM_HIGH = "IRA_RISK_LEVEL_MEDIUM_HIGH",
  /**
   * 高风险
   */
  IRA_RISK_LEVEL_HIGH = "IRA_RISK_LEVEL_HIGH",
  /**
   * 非常高
   */
  IRA_RISK_LEVEL_VERY_HIGH = "IRA_RISK_LEVEL_VERY_HIGH",
}

/**
 * IRA风险类型
 */
export enum IRARiskType {
  /**
   * 保守型
   */
  IRA_RISK_CONSERVATIVE = "IRA_RISK_CONSERVATIVE",
  /**
   * 谨慎型
   */
  IRA_RISK_CAUTIOUS = "IRA_RISK_CAUTIOUS",
  /**
   * 稳健型
   */
  IRA_RISK_MODERATE = "IRA_RISK_MODERATE",
  /**
   * 积极型
   */
  IRA_RISK_AGGRESSIVE = "IRA_RISK_AGGRESSIVE",
  /**
   * 激进型
   */
  IRA_RISK_VERY_AGGRESSIVE = "IRA_RISK_VERY_AGGRESSIVE",
}

/**
 * 后端没用到-KYC企业专业投资者类型
 */
export enum KYCCompanyProfessionalInvestorType {
  /**
   * 法团专业投资者
   */
  KYC_COMPANY_PROFESSIONAL_INVESTOR_TYPE_INDIVIDUAL = "KYC_COMPANY_PROFESSIONAL_INVESTOR_TYPE_INDIVIDUAL",
  /**
   * 机构专业投资者
   */
  KYC_COMPANY_PROFESSIONAL_INVESTOR_TYPE_COMPANY = "KYC_COMPANY_PROFESSIONAL_INVESTOR_TYPE_COMPANY",
}

/**
 * KYC国家分类
 */
export enum KYCCountryCategory {
  /**
   * 禁止国家：不允许进行KYC及相关服务
   */
  KYC_COUNTRY_FORBIDDEN = "KYC_COUNTRY_FORBIDDEN",
  /**
   * 准入国家：完全允许进行KYC及相关服务
   */
  KYC_COUNTRY_ALLOWED = "KYC_COUNTRY_ALLOWED",
  /**
   * 受限国家：部分服务受限，可能需要额外审核或材料
   */
  KYC_COUNTRY_RESTRICTED = "KYC_COUNTRY_RESTRICTED",
}

/**
 * KYC审核记录类型
 */
export enum KYCAuditRecordType {
  /**
   * 客户尽职调查
   */
  KYC_CDD = "KYC_CDD",
  /**
   * 补充资料审核
   */
  KYC_SUPPLEMENT = "KYC_SUPPLEMENT",
  /**
   * 加强尽职调查审核
   */
  KYC_EDD = "KYC_EDD",
  /**
   * 专业投资者测评审核
   */
  KYC_PI_ASSESS = "KYC_PI_ASSESS",
}

/**
 * KYC状态
 */
export enum KYCStatus {
  /**
   * 待提交
   */
  KYC_TO_BE_SUBMIT = "KYC_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  KYC_UNDER_REVIEW = "KYC_UNDER_REVIEW",
  /**
   * 已完成
   */
  KYC_COMPLETED = "KYC_COMPLETED",
  /**
   * 已退回
   */
  KYC_RETURNED = "KYC_RETURNED",
  /**
   * 已过期
   */
  KYC_EXPIRED = "KYC_EXPIRED",
  /**
   * 永久拒绝
   */
  KYC_REJECTED = "KYC_REJECTED",
}

/**
 * KYC用户类型
 */
export enum KYCUserType {
  /**
   * 零售投资者
   */
  KYC_USER_RETAIL = "KYC_USER_RETAIL",
  /**
   * 专业投资者
   */
  KYC_USER_PI = "KYC_USER_PI",
}

/**
 * KYC类型
 */
export enum KYCType {
  /**
   * 个人
   */
  KYC_PERSONAL = "KYC_PERSONAL",
  /**
   * 企业
   */
  KYC_COMPANY = "KYC_COMPANY",
}

/**
 * KYC配置项Key
 */
export enum KYCConfigKey {
  /**
   * 专业投资者测评最大尝试次数
   */
  KYC_PI_ASSESS_MAX_TIMES = "KYC_PI_ASSESS_MAX_TIMES",
  /**
   * 专业投资者测评失败冻结天数
   */
  KYC_PI_ASSESS_FREEZE_DAYS = "KYC_PI_ASSESS_FREEZE_DAYS",
  /**
   * 字段加密版本号
   */
  KYC_FIELD_ENCRYPT_VERSION = "KYC_FIELD_ENCRYPT_VERSION",
  /**
   * Sumsub认证级别
   */
  KYC_SUMSUB_LEVEL = "KYC_SUMSUB_LEVEL",
}

/**
 * QA分组类型
 */
export enum QAGroupName {
  /**
   * 投资者风险测评
   */
  QA_INVESTOR_RISK_ASSESSMENT = "QA_INVESTOR_RISK_ASSESSMENT",
  /**
   * 虚拟资产知识测评
   */
  QA_VIRTUAL_ASSET = "QA_VIRTUAL_ASSET",
}

/**
 * Sumsub状态
 */
export enum SumsubStatus {
  /**
   * 未认证
   */
  SUMSUB_NOT_AUTHENTICATED = "SUMSUB_NOT_AUTHENTICATED",
  /**
   * 认证中
   */
  SUMSUB_AUTHENTICATING = "SUMSUB_AUTHENTICATING",
  /**
   * 认证通过
   */
  SUMSUB_PASSED = "SUMSUB_PASSED",
  /**
   * 失败
   */
  SUMSUB_FAILED = "SUMSUB_FAILED",
}

/**
 * VAT状态
 */
export enum VATStatus {
  /**
   * 未通过
   */
  VAT_FAILED = "VAT_FAILED",
  /**
   * 通过
   */
  VAT_PASSED = "VAT_PASSED",
  /**
   * 待提交
   */
  VAT_TO_BE_SUBMIT = "VAT_TO_BE_SUBMIT",
}

/**
 * 专业投资者状态
 */
export enum ProfessionalInvestorStatus {
  /**
   * 待提交
   */
  PI_TO_BE_SUBMIT = "PI_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  PI_UNDER_REVIEW = "PI_UNDER_REVIEW",
  /**
   * 运营通过
   */
  PI_APPROVED = "PI_APPROVED",
  /**
   * 运营退回
   */
  PI_RETURNED = "PI_RETURNED",
  /**
   * 合规审核中
   */
  PI_COMPLIANCE_UNDER_REVIEW = "PI_COMPLIANCE_UNDER_REVIEW",
  /**
   * 合规审核通过
   */
  PI_COMPLIANCE_APPROVED = "PI_COMPLIANCE_APPROVED",
  /**
   * 合规审核退回
   */
  PI_COMPLIANCE_RETURNED = "PI_COMPLIANCE_RETURNED",
  /**
   * 需要更新
   */
  PI_NEED_UPDATE = "PI_NEED_UPDATE",
}

/**
 * 专业投资者类型
 */
export enum ProfessionalInvestorType {
  /**
   * 用户提交
   */
  PIT_USER_SUBMIT = "PIT_USER_SUBMIT",
  /**
   * 用户升级
   */
  PIT_USER_UPGRADE = "PIT_USER_UPGRADE",
  /**
   * 运营审核通过
   */
  PIT_OPERATION_APPROVED = "PIT_OPERATION_APPROVED",
  /**
   * 运行审核退回
   */
  PIT_OPERATION_RETURNED = "PIT_OPERATION_RETURNED",
  /**
   * 降级
   */
  PIT_AUTO_DEGRADE = "PIT_AUTO_DEGRADE",
  /**
   * 合规审核通过
   */
  PIT_COMPLIANCE_APPROVED = "PIT_COMPLIANCE_APPROVED",
  /**
   * 合规审核退回
   */
  PIT_COMPLIANCE_RETURNED = "PIT_COMPLIANCE_RETURNED",
}

/**
 * 加强尽职调查状态
 */
export enum EnhancedDueDiligenceStatus {
  /**
   * 待提交
   */
  EDD_TO_BE_SUBMIT = "EDD_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  EDD_UNDER_REVIEW = "EDD_UNDER_REVIEW",
  /**
   * RO审核通过
   */
  EDD_APPROVED = "EDD_APPROVED",
  /**
   * RO审核退回
   */
  EDD_RETURNED = "EDD_RETURNED",
  /**
   * RO拒绝
   */
  EDD_REJECTED = "EDD_REJECTED",
  /**
   * 不需要提交
   */
  EDD_NOT_SUBMIT = "EDD_NOT_SUBMIT",
}

/**
 * 加强尽职调查类型
 */
export enum EnhancedDueDiligenceType {
  /**
   * 自动触发
   */
  EDD_AUTO_TRIGGER = "EDD_AUTO_TRIGGER",
  /**
   * 手动触发
   */
  EDD_TRIGGER = "EDD_TRIGGER",
  /**
   * 提交资料
   */
  EDD_SUBMIT = "EDD_SUBMIT",
  /**
   * 填写审核意见
   */
  EDD_ADD_COMMENT = "EDD_ADD_COMMENT",
  /**
   * 审核通过
   */
  EDD_RO_APPROVED = "EDD_RO_APPROVED",
  /**
   * 审核拒绝
   */
  EDD_RO_REJECTED = "EDD_RO_REJECTED",
  /**
   * 审核退回
   */
  EDD_RO_RETURNED = "EDD_RO_RETURNED",
}

/**
 * 客户尽职调查状态
 */
export enum CustomerDueDiligenceStatus {
  /**
   * 待提交
   */
  CDD_TO_BE_SUBMIT = "CDD_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  CDD_UNDER_REVIEW = "CDD_UNDER_REVIEW",
  /**
   * 运营通过
   */
  CDD_APPROVED = "CDD_APPROVED",
  /**
   * 运营退回
   */
  CDD_RETURNED = "CDD_RETURNED",
  /**
   * 需要更新
   */
  CDD_NEED_UPDATE = "CDD_NEED_UPDATE",
  /**
   * 过期
   */
  CDD_EXPIRED = "CDD_EXPIRED",
}

/**
 * 客户尽职调查类型
 */
export enum CustomerDueDiligenceType {
  /**
   * 客户提交
   */
  CDD_USER_SUBMIT = "CDD_USER_SUBMIT",
  /**
   * 运营审核通过
   */
  CDD_OPERATION_APPROVED = "CDD_OPERATION_APPROVED",
  /**
   * 运营审核退回
   */
  CDD_OPERATION_RETURNED = "CDD_OPERATION_RETURNED",
  /**
   * 触发需要更新
   */
  CDD_TRIGGER_NEED_UPDATE = "CDD_TRIGGER_NEED_UPDATE",
  /**
   * 触发过期
   */
  CDD_TRIGGER_EXPIRED = "CDD_TRIGGER_EXPIRED",
  /**
   * 触发EDD
   */
  CDD_TRIGGER_EDD = "CDD_TRIGGER_EDD",
}

/**
 * 补充资料状态
 */
export enum SupplementaryMaterialsStatus {
  /**
   * 不需要提交
   */
  SM_NOT_SUBMIT = "SM_NOT_SUBMIT",
  /**
   * 待提交
   */
  SM_TO_BE_SUBMIT = "SM_TO_BE_SUBMIT",
  /**
   * 已提交
   */
  SM_SUBMITTED = "SM_SUBMITTED",
}

/**
 * 补充资料类型
 */
export enum SupplementaryMaterialsType {
  /**
   * 触发补充
   */
  SM_TRIGGER = "SM_TRIGGER",
  /**
   * 用户提交资料
   */
  SM_USER_SUBMIT = "SM_USER_SUBMIT",
  /**
   * 管理员提交资料
   */
  SM_ADMIN_SUBMIT = "SM_ADMIN_SUBMIT",
}

/**
 * 转账状态
 */
export enum TransferStatus {
  /**
   * 待转账
   */
  TRANSFER_TO_BE_SUBMIT = "TRANSFER_TO_BE_SUBMIT",
  /**
   * 转账中
   */
  TRANSFER_IN_PROGRESS = "TRANSFER_IN_PROGRESS",
  /**
   * 转账成功
   */
  TRANSFER_SUCCESS = "TRANSFER_SUCCESS",
  /**
   * 转账失败
   */
  TRANSFER_FAILED = "TRANSFER_FAILED",
}

/**
 * 用户端-个人kyc-交易目的
 */
export enum TradingPurposeOptions {
  /**
   * 商业交易
   */
  COMMERCIAL_TRADING = "COMMERCIAL_TRADING",
  /**
   * 投机交易
   */
  SPECULATIVE_TRADING = "SPECULATIVE_TRADING",
  /**
   * 投资交易
   */
  INVESTMENT_TRADING = "INVESTMENT_TRADING",
  /**
   * 捐赠或公益用途
   */
  DONATION_CHARITY = "DONATION_CHARITY",
  /**
   * 商品或服务款项支付
   */
  GOODS_SERVICES_PAYMENT = "GOODS_SERVICES_PAYMENT",
  /**
   * 货币兑换
   */
  CURRENCY_EXCHANGE = "CURRENCY_EXCHANGE",
}

/**
 * 用户端-个人kyc-就业状态
 */
export enum EmploymentStatusOptions {
  /**
   * 全职受雇
   */
  FULL_TIME_EMPLOYED = "FULL_TIME_EMPLOYED",
  /**
   * 兼职受雇
   */
  PART_TIME_EMPLOYED = "PART_TIME_EMPLOYED",
  /**
   * 自雇
   */
  SELF_EMPLOYED = "SELF_EMPLOYED",
  /**
   * 退休
   */
  RETIRED = "RETIRED",
  /**
   * 学生
   */
  STUDENT = "STUDENT",
  /**
   * 家庭主妇
   */
  HOMEMAKER = "HOMEMAKER",
  /**
   * 无业
   */
  UNEMPLOYED = "UNEMPLOYED",
}

/**
 * 用户端-个人kyc-居住证明文件类型
 */
export enum AddressProofTypeOptions {
  /**
   * 水电煤气账单
   */
  UTILITY_BILL = "UTILITY_BILL",
  /**
   * 金融机构账单
   */
  FINANCIAL_STATEMENT = "FINANCIAL_STATEMENT",
  /**
   * 通信类账单
   */
  TELECOM_BILL = "TELECOM_BILL",
  /**
   * 住宅类租房合同
   */
  RESIDENTIAL_LEASE = "RESIDENTIAL_LEASE",
  /**
   * 酒店公寓租房合同
   */
  HOTEL_APARTMENT_LEASE = "HOTEL_APARTMENT_LEASE",
  /**
   * 特殊职业单位证明
   */
  SPECIAL_EMPLOYMENT_CERTIFICATE = "SPECIAL_EMPLOYMENT_CERTIFICATE",
}

/**
 * 用户端-个人kyc-年收入
 */
export enum IncomeOptions {
  /**
   * < 25,000 USD
   */
  less_than_25000 = "less_than_25000",
  /**
   * 25,000 – 50,000 USD
   */
  V_25000_50000 = "25000_50000",
  /**
   * 50,000 – 100,000 USD
   */
  V_50000_100000 = "50000_100000",
  /**
   * 100,000 – 250,000 USD
   */
  V_100000_250000 = "100000_250000",
  /**
   * 250,000 – 500,000 USD
   */
  V_250000_500000 = "250000_500000",
  /**
   * 500,000 USD – 2,000,000 USD
   */
  V_500000_2000000 = "500000_2000000",
  /**
   * > 2,000,000 USD
   */
  more_than_2000000 = "more_than_2000000",
}

/**
 * 用户端-个人kyc-收入来源
 */
export enum IncomeSourceOptions {
  /**
   * 薪资
   */
  SALARY = "SALARY",
  /**
   * 收入积蓄
   */
  INCOME_SAVINGS = "INCOME_SAVINGS",
  /**
   * 佣金或营业收入
   */
  COMMISSION_BUSINESS_INCOME = "COMMISSION_BUSINESS_INCOME",
  /**
   * 退休金或准备金
   */
  PENSION_RESERVES = "PENSION_RESERVES",
  /**
   * 投资收入
   */
  INVESTMENT_INCOME = "INVESTMENT_INCOME",
  /**
   * 其他
   */
  OTHER = "OTHER",
}

/**
 * 用户端-个人kyc-海外居留证件类型
 */
export enum TemporaryResidenceDocumentOptions {
  /**
   * 香港居民身份证
   */
  TEMPORARY_ID_CARD = "TEMPORARY_ID_CARD",
  /**
   * 签证
   */
  VISA = "VISA",
}

/**
 * 用户端-个人kyc-行业
 */
export enum IndustryOptions {
  /**
   * 农业、林业和渔业工作者
   */
  Agricultural_Forestry_and_Fishing_Workers = "Agricultural, Forestry, and Fishing Workers",
  /**
   * 采矿业工作者
   */
  Mining_Workers = "Mining Workers",
  /**
   * 制造业工作者
   */
  Manufacturing_Workers = "Manufacturing Workers",
  /**
   * 电力、燃气、蒸汽和空调供应业工作者
   */
  Workers_in_Electricity_Gas_Steam_and_Air_Conditioning_Supply = "Workers in Electricity, Gas, Steam, and Air Conditioning Supply",
  /**
   * 供水；污水处理、废物管理和修复活动工作者
   */
  Workers_in_Water_Supply_Sewerage_Waste_Management_and_Remediation_Activities = "Workers in Water Supply; Sewerage, Waste Management, and Remediation Activities",
  /**
   * 建筑业工作者
   */
  Construction_Workers = "Construction Workers",
  /**
   * 批发和零售贸易工作者
   */
  Wholesale_and_Retail_Trade_Workers = "Wholesale and Retail Trade Workers",
  /**
   * 运输和仓储业工作者
   */
  Transportation_and_Storage_Workers = "Transportation and Storage Workers",
  /**
   * 住宿和餐饮服务业工作者
   */
  Accommodation_and_Food_Service_Workers = "Accommodation and Food Service Workers",
  /**
   * 信息和通信业工作者
   */
  Information_and_Communication_Workers = "Information and Communication Workers",
  /**
   * 金融和保险业工作者
   */
  Financial_and_Insurance_Workers = "Financial and Insurance Workers",
  /**
   * 房地产业工作者
   */
  Real_Estate_Workers = "Real Estate Workers",
  /**
   * 专业、科学和技术服务业工作者
   */
  Professional_Scientific_and_Technical_Service_Workers = "Professional, Scientific, and Technical Service Workers",
  /**
   * 行政和支持服务业工作者
   */
  Administrative_and_Support_Service_Workers = "Administrative and Support Service Workers",
  /**
   * 公共管理、国防和社会保障工作者
   */
  Public_Administration_Defence_and_Social_Security_Workers = "Public Administration, Defence, and Social Security Workers",
  /**
   * 教育服务业工作者
   */
  Education_Service_Workers = "Education Service Workers",
  /**
   * 卫生和社会工作服务业工作者
   */
  Health_and_Social_Work_Service_Workers = "Health and Social Work Service Workers",
  /**
   * 艺术、体育和娱乐相关服务业工作者
   */
  Arts_Sports_and_Recreation_Related_Service_Workers = "Arts, Sports, and Recreation Related Service Workers",
  /**
   * 会员组织、维修和其他个人服务业工作者
   */
  Workers_in_Membership_Organisations_Repair_and_Other_Personal_Services = "Workers in Membership Organisations, Repair, and Other Personal Services",
  /**
   * 家政服务和其他未分类活动工作者
   */
  Domestic_Workers_and_Other_Workers_in_Activities_Not_Elsewhere_Classified = "Domestic Workers and Other Workers in Activities Not Elsewhere Classified",
  /**
   * 国际和外国组织工作者
   */
  International_and_Foreign_Organisation_Workers = "International and Foreign Organisation Workers",
  /**
   * 政治家、高级官员和管理人员
   */
  Politicians_Senior_Officials_and_Managers = "Politicians, Senior Officials, and Managers",
  /**
   * 博彩业工作者
   */
  Gambling_Industry_Workers = "Gambling Industry Workers",
  /**
   * 货币兑换业工作者
   */
  Currency_Exchange_Workers = "Currency Exchange Workers",
  /**
   * 放贷业工作者
   */
  Money_Lending_Workers = "Money Lending Workers",
  /**
   * 贵金属业工作者
   */
  Precious_Metals_Workers = "Precious Metals Workers",
  /**
   * 便利店工作者
   */
  Convenience_Store_Workers = "Convenience Store Workers",
  /**
   * 专业服务业工作者
   */
  Professional_Service_Workers = "Professional Service Workers",
  /**
   * 金融投资业工作者
   */
  Financial_Investment_Workers = "Financial Investment Workers",
  /**
   * 信托业工作者
   */
  Trust_Business_Workers = "Trust Business Workers",
  /**
   * 虚拟资产行业工作者
   */
  Virtual_Asset_Industry_Workers = "Virtual Asset Industry Workers",
  /**
   * 网上购物商城工作者
   */
  Internet_Shopping_Mall_Workers = "Internet Shopping Mall Workers",
  /**
   * 贸易业工作者
   */
  Trading_Workers = "Trading Workers",
  /**
   * 军工和国防工业工作者
   */
  Arms_and_Defence_Industry_Workers = "Arms and Defence Industry Workers",
  /**
   * 开采业工作者
   */
  Extraction_Industry_Workers = "Extraction Industry Workers",
  /**
   * 非营利组织和宗教团体工作者
   */
  Workers_in_Non_Profit_Organisations_and_Religious_Groups = "Workers in Non-Profit Organisations and Religious Groups",
  /**
   * 废品回收业工作者
   */
  Scrap_Dealers_Workers = "Scrap Dealers Workers",
  /**
   * 个体经营者
   */
  Self_employed = "Self-employed",
  /**
   * 失业人员
   */
  Unemployed = "Unemployed",
  /**
   * 退休人员
   */
  Retired = "Retired",
}

/**
 * 用户端-个人kyc-证件类型
 */
export enum IdentificationDocumentOptions {
  /**
   * 香港永久居民身份证
   */
  ID_CARD = "ID_CARD",
  /**
   * 护照
   */
  PASSPORT = "PASSPORT",
}

/**
 * 用户端-企业kyc-上市状态
 */
export enum ListingStatusOptions {
  /**
   * 上市公司
   */
  YES = "YES",
  /**
   * 非上市公司
   */
  NO = "NO",
}

/**
 * 用户端-企业kyc-公司股东财富来源
 */
export enum CompanyKycIndividualShareholderWealthSourceOptions {
  /**
   * 薪资
   */
  SALARY = "SALARY",
  /**
   * 收入积蓄
   */
  INCOME_SAVINGS = "INCOME_SAVINGS",
  /**
   * 佣金/营业收入
   */
  COMMISSION_BUSINESS_INCOME = "COMMISSION_BUSINESS_INCOME",
  /**
   * 退休金/准备金
   */
  PENSION_RESERVES = "PENSION_RESERVES",
  /**
   * 投资收入
   */
  INVESTMENT_INCOME = "INVESTMENT_INCOME",
  /**
   * 遗产/赠与
   */
  INHERITANCE_GIFT = "INHERITANCE_GIFT",
  /**
   * 资产出售
   */
  ASSET_SALE = "ASSET_SALE",
  /**
   * 借款/贷款
   */
  LOAN_BORROWING = "LOAN_BORROWING",
  /**
   * 其他
   */
  OTHER = "OTHER",
}

/**
 * 用户端-企业kyc-公司关联人士类型
 */
export enum CompanyRelatedPersonTypeOptions {
  /**
   * 股东/最终实益拥有人
   */
  SHAREHOLDER_BENEFICIAL_OWNER = "SHAREHOLDER_BENEFICIAL_OWNER",
  /**
   * 看似代表客户行事的人
   */
  CLIENT_REPRESENTATIVE = "CLIENT_REPRESENTATIVE",
  /**
   * 可发出签署指示的授权签署人
   */
  AUTHORIZED_SIGNATORY = "AUTHORIZED_SIGNATORY",
  /**
   * 委托人
   */
  PRINCIPAL = "PRINCIPAL",
  /**
   * 董事
   */
  DIRECTOR = "DIRECTOR",
  /**
   * 受托人
   */
  TRUSTEE = "TRUSTEE",
  /**
   * 其他有关人士
   */
  OTHER_RELATED_PERSON = "OTHER_RELATED_PERSON",
}

/**
 * 用户端-企业kyc-公司类型
 */
export enum CompanyTypeOptions {
  /**
   * 非营利性组织
   */
  NON_PROFIT = "NON_PROFIT",
  /**
   * 营利性公司
   */
  FOR_PROFIT = "FOR_PROFIT",
  /**
   * 政府/半政府机构
   */
  GOVERNMENT = "GOVERNMENT",
}

/**
 * 用户端-企业kyc-法人股东财富来源
 */
export enum CompanyLegalPersonShareholderWealthSourceOptions {
  /**
   * 股东/合伙人资金
   */
  SHAREHOLDER_PARTNER_FUNDS = "SHAREHOLDER_PARTNER_FUNDS",
  /**
   * 经营收入
   */
  OPERATING_INCOME = "OPERATING_INCOME",
  /**
   * 投资收入
   */
  INVESTMENT_INCOME = "INVESTMENT_INCOME",
  /**
   * 出售投资
   */
  INVESTMENT_SALE = "INVESTMENT_SALE",
  /**
   * 对外借贷
   */
  EXTERNAL_BORROWING = "EXTERNAL_BORROWING",
  /**
   * 利息收入
   */
  INTEREST_INCOME = "INTEREST_INCOME",
  /**
   * 股息收入
   */
  DIVIDEND_INCOME = "DIVIDEND_INCOME",
  /**
   * 租金收入
   */
  RENTAL_INCOME = "RENTAL_INCOME",
  /**
   * 其他
   */
  OTHER = "OTHER",
}

/**
 * 用户端-企业kyc-关联方角色
 */
export enum CompanyShareholderTypeOptions {
  /**
   * 个人股东/有关人士
   */
  INDIVIDUAL = "INDIVIDUAL",
  /**
   * 法人股东/有关人士
   */
  CORPORATE = "CORPORATE",
}

/**
 * 用户端-企业kyc-行业
 */
export enum CompanyIndustryOptions {
  /**
   * 农业、林业和渔业
   */
  Agriculture_Forestry_and_Fishing = "Agriculture, Forestry and Fishing",
  /**
   * 采矿业
   */
  Mining = "Mining",
  /**
   * 制造业
   */
  Manufacturing = "Manufacturing",
  /**
   * 电力、燃气、蒸汽和空调供应业
   */
  Electricity_Gas_Steam_and_Air_Conditioning_Supply = "Electricity, Gas, Steam and Air Conditioning Supply",
  /**
   * 水的生产和供应业；污水处理、废物管理和环境修复活动
   */
  Water_Supply_Sewerage_Waste_Management_and_Remediation_Activities = "Water Supply; Sewerage, Waste Management and Remediation Activities",
  /**
   * 建筑业
   */
  Construction = "Construction",
  /**
   * 批发和零售贸易
   */
  Wholesale_and_Retail_Trade = "Wholesale and Retail Trade",
  /**
   * 交通运输和仓储业
   */
  Transportation_and_Storage = "Transportation and Storage",
  /**
   * 住宿和餐饮服务业
   */
  Accommodation_and_Food_Service_Activities = "Accommodation and Food Service Activities",
  /**
   * 信息传输和通信业
   */
  Information_and_Communication = "Information and Communication",
  /**
   * 金融和保险业
   */
  Financial_and_Insurance_Activities = "Financial and Insurance Activities",
  /**
   * 房地产业
   */
  Real_Estate_Activities = "Real Estate Activities",
  /**
   * 专业、科学和技术服务业
   */
  Professional_Scientific_and_Technical_Services = "Professional, Scientific and Technical Services",
  /**
   * 行政和支持服务业
   */
  Administrative_and_Support_Service_Activities = "Administrative and Support Service Activities",
  /**
   * 公共管理和国防；强制性社会保障
   */
  Public_Administration_and_Defence_Compulsory_Social_Security = "Public Administration and Defence; Compulsory Social Security",
  /**
   * 教育
   */
  Education = "Education",
  /**
   * 卫生和社会工作
   */
  Human_Health_and_Social_Work_Activities = "Human Health and Social Work Activities",
  /**
   * 文化、体育和娱乐业
   */
  Arts_Entertainment_and_Recreation = "Arts, Entertainment and Recreation",
  /**
   * 其他服务业
   */
  Other_Service_Activities = "Other Service Activities",
  /**
   * 家庭雇主活动；家庭自用的无差别商品和服务生产活动
   */
  Activities_of_Households_as_Employers_Undifferentiated_Goods_and_Services_Producing_Activities_of_Households_for_Own_Use = "Activities of Households as Employers; Undifferentiated Goods- and Services-Producing Activities of Households for Own Use",
  /**
   * 境外组织和机构活动
   */
  Activities_of_Extraterritorial_Organisations_and_Bodies = "Activities of Extraterritorial Organisations and Bodies",
  /**
   * 政治、行政和管理职位
   */
  Political_Executive_and_Management_Positions = "Political, Executive, and Management Positions",
  /**
   * 博彩和投注活动
   */
  Gambling_and_Betting_Activities = "Gambling and Betting Activities",
  /**
   * 货币兑换服务
   */
  Currency_Exchange_Services = "Currency Exchange Services",
  /**
   * 放贷服务
   */
  Money_Lending_Services = "Money Lending Services",
  /**
   * 贵金属业务
   */
  Precious_Metals_Activities = "Precious Metals Activities",
  /**
   * 现金处理服务
   */
  Cash_Handling_Services = "Cash Handling Services",
  /**
   * 专业化专业服务
   */
  Specialised_Professional_Services = "Specialised Professional Services",
  /**
   * 金融投资活动
   */
  Financial_Investment_Activities = "Financial Investment Activities",
  /**
   * 信托和受托服务
   */
  Trust_and_Fiduciary_Services = "Trust and Fiduciary Services",
  /**
   * 通过邮购或互联网进行的在线零售
   */
  Online_Retail_Sale_via_Mail_Order_Houses_or_via_Internet = "Online Retail Sale via Mail Order Houses or via Internet",
  /**
   * 批发贸易，不包括机动车和摩托车
   */
  Wholesale_Trade_Except_of_Motor_Vehicles_and_Motorcycles = "Wholesale Trade, Except of Motor Vehicles and Motorcycles",
  /**
   * 武器和弹药制造
   */
  Manufacture_of_Weapons_and_Ammunition = "Manufacture of Weapons and Ammunition",
  /**
   * 其他采矿和采石
   */
  Other_Mining_and_Quarrying = "Other Mining and Quarrying",
  /**
   * 非营利组织和宗教机构活动
   */
  Activities_of_Non_profit_Organisations_and_Religious_Institutions = "Activities of Non-profit Organisations and Religious Institutions",
  /**
   * 店内二手商品零售
   */
  Retail_Sale_of_Second_Hand_Goods_in_Stores = "Retail Sale of Second-Hand Goods in Stores",
}

/**
 * 用户端-性别
 */
export enum GenderOptions {
  /**
   * 男
   */
  MALE = "MALE",
  /**
   * 女
   */
  FEMALE = "FEMALE",
}

/**
 * 用户端-是或否
 */
export enum YesNoOptions {
  /**
   * 是
   */
  YES = "YES",
  /**
   * 否
   */
  NO = "NO",
}

/**
 * 管理端-AML筛查-AML筛查
 */
export enum AMLScreeningOptions {
  /**
   * 无需审批
   */
  S = "S",
  /**
   * 需要审批
   */
  R = "R",
}

/**
 * 管理端-AML筛查-姓名筛查
 */
export enum AMLNameScreeningOptions {
  /**
   * 虚假命中
   */
  S = "S",
  /**
   * 真实命中拒绝
   */
  R = "R",
  /**
   * 真实命中接受
   */
  E = "E",
}

/**
 * 管理端-sumsub认证状态
 */
export enum SumsubAuthenticationStatusOptions {
  /**
   * 通过
   */
  SUMSUB_PASSED = "SUMSUB_PASSED",
  /**
   * 未通过
   */
  SUMSUB_FAILED = "SUMSUB_FAILED",
}

/**
 * 管理端-专业投资者操作类型
 */
export enum ProfessionalInvestorOperationTypeOptions {
  /**
   * 客户提交
   */
  PIT_USER_SUBMIT = "PIT_USER_SUBMIT",
  /**
   * 运营审核通过
   */
  PIT_OPERATION_APPROVED = "PIT_OPERATION_APPROVED",
  /**
   * 用户升级操作
   */
  PIT_USER_UPGRADE = "PIT_USER_UPGRADE",
  /**
   * 运营审核退回
   */
  PIT_OPERATION_RETURNED = "PIT_OPERATION_RETURNED",
  /**
   * 合规审核通过
   */
  PIT_COMPLIANCE_APPROVED = "PIT_COMPLIANCE_APPROVED",
  /**
   * 合规审核退回
   */
  PIT_COMPLIANCE_RETURNED = "PIT_COMPLIANCE_RETURNED",
  /**
   * 需要更新
   */
  PIT_NEED_UPDATE = "PIT_NEED_UPDATE",
}

/**
 * 管理端-专业投资者认证状态
 */
export enum ProfessionalInvestorTypeStatusOptions {
  /**
   * 待提交
   */
  PI_TO_BE_SUBMIT = "PI_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  PI_UNDER_REVIEW = "PI_UNDER_REVIEW",
  /**
   * 已通过
   */
  PI_APPROVED = "PI_APPROVED",
  /**
   * 已退回
   */
  PI_RETURNED = "PI_RETURNED",
}

/**
 * 管理端-加强尽职调查状态
 */
export enum EnhancedDueDiligenceStatusOptions {
  /**
   * 待提交
   */
  EDD_TO_BE_SUBMIT = "EDD_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  EDD_UNDER_REVIEW = "EDD_UNDER_REVIEW",
  /**
   * 已通过
   */
  EDD_APPROVED = "EDD_APPROVED",
  /**
   * 已退回
   */
  EDD_RETURNED = "EDD_RETURNED",
  /**
   * 已拒绝
   */
  EDD_REJECTED = "EDD_REJECTED",
  /**
   * 不需要提交
   */
  EDD_NOT_SUBMIT = "EDD_NOT_SUBMIT",
}

/**
 * 管理端-客户尽职调查-列表筛选-认证类型
 */
export enum KYCAuthenticationTypeOptions {
  /**
   * 个人用户
   */
  KYC_PERSONAL = "KYC_PERSONAL",
  /**
   * 企业用户
   */
  KYC_COMPANY = "KYC_COMPANY",
}

/**
 * 管理端-客户尽职调查状态
 */
export enum CustomerDueDiligenceStatusOptions {
  /**
   * 待提交
   */
  CDD_TO_BE_SUBMIT = "CDD_TO_BE_SUBMIT",
  /**
   * 审核中
   */
  CDD_UNDER_REVIEW = "CDD_UNDER_REVIEW",
  /**
   * 已通过
   */
  CDD_APPROVED = "CDD_APPROVED",
  /**
   * 已退回
   */
  CDD_RETURNED = "CDD_RETURNED",
  /**
   * 需要更新
   */
  CDD_NEED_UPDATE = "CDD_NEED_UPDATE",
  /**
   * 证件过期
   */
  CDD_EXPIRED = "CDD_EXPIRED",
}

/**
 * 管理端-投资者承受能力测试状态
 */
export enum InvestorRiskToleranceTestTypeStatusOptions {
  /**
   * 未通过
   */
  IRA_FAILED = "IRA_FAILED",
  /**
   * 通过
   */
  IRA_PASSED = "IRA_PASSED",
  /**
   * 待提交
   */
  IRA_TO_BE_SUBMIT = "IRA_TO_BE_SUBMIT",
  /**
   * 已过期
   */
  IRA_EXPIRED = "IRA_EXPIRED",
}

/**
 * 管理端-投资者承受能力结果类型
 */
export enum InvestorRiskToleranceResultTypeOptions {
  /**
   * 保守型
   */
  IRA_RISK_CONSERVATIVE = "IRA_RISK_CONSERVATIVE",
  /**
   * 谨慎型
   */
  IRA_RISK_CAUTIOUS = "IRA_RISK_CAUTIOUS",
  /**
   * 稳健型
   */
  IRA_RISK_MODERATE = "IRA_RISK_MODERATE",
  /**
   * 积极型
   */
  IRA_RISK_AGGRESSIVE = "IRA_RISK_AGGRESSIVE",
  /**
   * 激进型
   */
  IRA_RISK_VERY_AGGRESSIVE = "IRA_RISK_VERY_AGGRESSIVE",
}

/**
 * 管理端-白名单管理-验证方式
 */
export enum WhiteListVerificationMethodOptions {
  /**
   * 签名验证
   */
  SIGNATURE = "SIGNATURE",
  /**
   * 充值验证
   */
  DEPOSIT = "DEPOSIT",
}

/**
 * 管理端-虚拟币充值-KYTKYA风险等级
 */
export enum TokenRechargeKYTAndKYARiskLevelOptions {
  /**
   * 高风险
   */
  HIGH = "HIGH",
  /**
   * 中风险
   */
  MEDIUM = "MEDIUM",
  /**
   * 低风险
   */
  LOW = "LOW",
}

/**
 * 管理端-虚拟币充值-充值类型
 */
export enum TokenRechargeTypeOptions {
  /**
   * 个人钱包充值
   */
  SOURCE_PERSONAL = "SOURCE_PERSONAL",
  /**
   * 第三方交易所充值
   */
  SOURCE_EXCHANGE = "SOURCE_EXCHANGE",
}

/**
 * 管理端-虚拟币充值-审核状态
 */
export enum TokenRechargeAuditStatusOptions {
  /**
   * 合规审核
   */
  IN_REVIEW_COMPLIANCE = "IN_REVIEW_COMPLIANCE",
  /**
   * RO审核
   */
  IN_REVIEW_RO = "IN_REVIEW_RO",
}

export type OptionsType =
  | "CRAStatus"
  | "Creator"
  | "IRAStatus"
  | "IRARiskLevel"
  | "IRARiskType"
  | "KYCCompanyProfessionalInvestorType"
  | "KYCCountryCategory"
  | "KYCAuditRecordType"
  | "KYCStatus"
  | "KYCUserType"
  | "KYCType"
  | "KYCConfigKey"
  | "QAGroupName"
  | "SumsubStatus"
  | "VATStatus"
  | "ProfessionalInvestorStatus"
  | "ProfessionalInvestorType"
  | "EnhancedDueDiligenceStatus"
  | "EnhancedDueDiligenceType"
  | "CustomerDueDiligenceStatus"
  | "CustomerDueDiligenceType"
  | "SupplementaryMaterialsStatus"
  | "SupplementaryMaterialsType"
  | "TransferStatus"
  | "TradingPurposeOptions"
  | "EmploymentStatusOptions"
  | "AddressProofTypeOptions"
  | "IncomeOptions"
  | "IncomeSourceOptions"
  | "TemporaryResidenceDocumentOptions"
  | "IndustryOptions"
  | "IdentificationDocumentOptions"
  | "ListingStatusOptions"
  | "CompanyKycIndividualShareholderWealthSourceOptions"
  | "CompanyRelatedPersonTypeOptions"
  | "CompanyTypeOptions"
  | "CompanyLegalPersonShareholderWealthSourceOptions"
  | "CompanyShareholderTypeOptions"
  | "CompanyIndustryOptions"
  | "GenderOptions"
  | "YesNoOptions"
  | "AMLScreeningOptions"
  | "AMLNameScreeningOptions"
  | "SumsubAuthenticationStatusOptions"
  | "ProfessionalInvestorOperationTypeOptions"
  | "ProfessionalInvestorTypeStatusOptions"
  | "EnhancedDueDiligenceStatusOptions"
  | "KYCAuthenticationTypeOptions"
  | "CustomerDueDiligenceStatusOptions"
  | "InvestorRiskToleranceTestTypeStatusOptions"
  | "InvestorRiskToleranceResultTypeOptions"
  | "WhiteListVerificationMethodOptions"
  | "TokenRechargeKYTAndKYARiskLevelOptions"
  | "TokenRechargeTypeOptions"
  | "TokenRechargeAuditStatusOptions";
